export const menuItems = [
    {
        label: "Dashboard",
        perm:'view_dashboard',
        icon: "mdi mdi-apps",
        link: "/"
    },
    {
        label: "Patients",
        icon: "bx-user-circle",
        perm:'view_patients',
        subItems: [
            {
                label: "Add Patient",
                perm:'new_patient',
                link: "/newpatient",
            },
            {
                label: "Patient Triage",
                perm:'patient_triage',
                link: "/traige",
            },
            {
                label: "Active Visits",
                perm:'patient_visits',
                link: "/patientvisits",
            },
            {
                label: "View Patients",
                perm:'patient_view',
                link: "/viewpatient",
            },
            {
                label: "Appointments",
                perm:'patient_appointments',
                link: "/appointments",
            },
        ]
    },
    {
        label: "Finance",
        icon: "mdi mdi-cash-check",
        perm:'view_finance',
        subItems: [
            {
                label: "Patient Payments",
                perm:'patient_payments',
                link: "/patientpayments",
            },
            {
                label: "Patient Debts",
                perm:'patient_debts',
                link: "/debtors",
            },
            {
                label: "Insurance",
                perm:'insurance_patients',
                subItems: [
                    {
                        label: "Companies",
                        perm:'insurance_patients',
                        link: "/insurancecompanies",
                    },
                    {
                        label: "Packages",
                        perm:'insurance_patients',
                        link: "/insurancepackages",
                    },
                    {
                        label: "Patients",
                        perm:'insurance_patients',
                        link: "/insurancepatients",
                    },
                    {
                        label: "Invoices",
                        perm:'insurance_patients',
                        link: "/insuranceinvoices",
                    },
                   
                ]
            },
            {
                label: "Group Accounts",
                perm:'insurance_patients',
                subItems: [
                    {
                        label: "Account Members",
                        perm:'insurance_patients',
                        link: "/groupaccounts",
                    },
                    {
                        label: "Account Invoices",
                        perm:'insurance_patients',
                        link: "/accountinvoices",
                    },
                    
                ]
            },
            {
                label: "Saving Scheme",
                perm:'saving_scheme',
                subItems: [
                    {
                        label: "View Savings",
                        perm:'saving_scheme',
                        link: "/viewsavings",
                    },
                    {
                        label: "Account Balances",
                        perm:'saving_scheme',
                        link: "/accountbalances",
                    },
                ]
            },
            {
                label: "Expenses",
                icon: "mdi mdi-plus-circle-multiple",
                perm:'view_expenses',
                subItems: [
                    {
                        label: "Record Expense",
                        perm:'view_expenses',
                        link: "/recordexpense",
                    },
                    {
                        label: "View Expenses",
                        perm:'view_expenses',
                        link: "/viewexpenses",
                    },
                    {
                        label: "Expense Items",
                        perm:'view_expenses',
                        link: "/expenseitems",
                    },
                    {
                        label: "Expense Categories",
                        perm:'view_expenses',
                        link: "/expensecategories",
                    },
                ]
            },
        ]
    },
    {
        label: "Doctor",
        icon: "mdi mdi-doctor",
        perm:'view_doctor',
        subItems: [
            {
                label: "Consultation Patients",
                perm:'consultation_patients',
                link: "/consultation",
            },
            {
                label: "Procedure Patients",
                perm:'procedure_patients',
                link: "/procedure",
            },
            {
                label: "Dental Patients",
                perm:'dental_patients',
                link: "/dental",
            },
            {
                label: "Radiology Patients",
                perm:'radiology_patients',
                link: "/radiology",
            },
            {
                label: "Antenatal Patients",
                perm:'antenatal_patients',
                link: "/antenatal",
            },
            {
                label: "Maternity Patients",
                perm:'other_patients',
                link: "/maternity",
            },
            {
                label: "Theater Patients",
                perm:'other_patients',
                link: "/theater",
            },
            {
                label: "Other Patients",
                perm:'other_patients',
                link: "/otherservices",
            },
            {
                label: "Referred Patients",
                perm:'referpatient',
                link: "/referpatient",
            },
        ]
    },
    {
        label: "Nurse",
        icon: "mdi mdi-needle",
        perm:'view_doctor',
        subItems: [
            {
                label: "In Patients",
                perm:'view_doctor',
                link: "/inpatients",
            },
            {
                label: "Discharge a Patient",
                perm:'dischargepatient',
                link: "/dischargepatient",
            },
            {
                label: "Birth Certificate",
                perm:'view_doctor',
                link: "/birthcertificate",
            },
            {
                label: "Death Certificate",
                perm:'view_doctor',
                link: "/deathcertificate",
            },
            {
                label: "Consent Form",
                perm:'view_doctor',
                link: "/consentform",
            },
        ]
    },
    {
        label: "Appointments",
        icon:"mdi mdi-stethoscope",
        perm:'doctor_specialty',
        subItems: [
            {
                label: "Doctor",
                perm:'doctor_specialty',
                link: "/doctorspecialty",
                
            },
            {
                label: "Schedule",
                perm:'schedules',
                link: "/schedules",
            },
             {
                label: "App Booking",
                perm:'app_bookings',
                link: "/appbookings",
            },
            {
                label: "Drug Orders",
                perm:'drug_orders',
                link: "/drugs",
            },
        ]
    },
    {
        label: "Laboratory",
        perm:'view_radiography',
        icon: "mdi mdi-radiology-box",
        subItems: [
            {
                label: "Enter Test Results",
                perm:'enter_test_results',
                link: "/entertestresults",
            },
            {
                label: "Test Result Reports",
                perm:'test_results_report',
                link: "/testresultreports",
            },
        ]
    },
    
    {
        label: "Pharmacy",
        icon: "mdi mdi-pill",
        perm:'view_pharmacy',
        subItems: [
            {
                label: "Dispense Medicine",
                perm:'dispense_medicine',
                link: "/dispensemedicine",
            },
            {
                label: "Sell Medicine",
                perm:'sell_medicine',
                link: "/sellproduct",
            },
            {
                label: "Medicine Sales",
                perm:'sell_medicine',
                link: "/sellproductdetails",
            },
            {
                label: "Add Stock",
                perm:'add_stock',
                link: "/addstock",
            },
            {
                label: "Stock Levels",
                perm:'stock_levels',
                link: "/stocklevels",
            },
        ]
    },
    {
        label: "SMS Center",
        icon: "mdi mdi-comment",
        perm:'view_pharmacy',
        subItems: [
            {
                label: "Send Messages",
                perm:'view_pharmacy',
                link: "/smscenter",
            },
            {
                label: "Purchase SMS Bundles",
                perm:'view_pharmacy',
                // link: "/smspurchase",
                link: "/subscription",
            },
        ]
    },
];